function path(root, sublink) {
    return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';

export const PATH_AUTH = {
    root: ROOTS_AUTH,
    login: path(ROOTS_AUTH, '/login'),
    register: path(ROOTS_AUTH, '/register'),
    verify: path(ROOTS_AUTH, '/verify'),
    resetPassword: path(ROOTS_AUTH, '/reset-password'),
};
export const PATH_APP = {
    home: '/',
    verifySuccess: '/verify-success',
    userDisease: '/user-disease',
    activity: '/activity',
    diets: '/diets',
    loading: '/loading',
    support: '/support',
    userInformation: '/user-information',
    confirm: '/confirm',
    programs: '/programs',
    chat: '/chat',
    practices: '/practices',
    weightProcess: '/weight-process',
    createTicket: '/create-ticket',
    tickets: '/tickets',
    viewTicket: (id) => "/tickets/" + id,
    courses: '/courses',
    viewCourse: (id) => '/courses/' + id,
    dietType: '/select-diet',
    bodyInformation: '/body-information',
    confirmPurchase: (id) => '/confirm-purchase/' + id,
    verifyPurchase: 'verify-purchase',
    profile:"/profile",
};
